import { useSearchParams } from "react-router";

/** The `?features=` token that unlocks debugger-only UI. */
export const DEBUGGER_FEATURE = "debugger";

/** Whether a comma-separated `features` query value enables the debugger. */
function featuresEnableDebugger(features: string | null | undefined): boolean {
	return Boolean(features?.split(",").includes(DEBUGGER_FEATURE));
}

/**
 * Server-side (loader/action) mirror of {@link useFeatureFlags}: reads the
 * `?features=debugger` flag off a `Request`. Shares its parsing with the hook so
 * the two can't drift.
 */
export function isDebuggerEnabledInRequest(request: Request): boolean {
	return featuresEnableDebugger(
		new URL(request.url).searchParams.get("features"),
	);
}

export function useFeatureFlags() {
	const [params] = useSearchParams();
	const isDebuggerEnabled = featuresEnableDebugger(params.get("features"));

	return { isDebuggerEnabled };
}
